import React from 'react'
import PropTypes from 'prop-types'
import styles from './UsersList.scss'
import { Link } from 'react-router-dom'
import { Breadcrumb, BreadcrumbItem, Button, Table } from 'reactstrap'
import { FaPlus } from 'react-icons/lib/fa'
import Pagination from '../../components/Pagination'
import SortableTableHeader from '../../components/SortableTableHeader'

const sortableHeaders = {
  email: 'email',
  firstName: 'First Name',
  lastName: 'Last Name'
}

const UsersList = props =>
  <div className={styles.UsersList}>
    <div>
      <Breadcrumb>
        <BreadcrumbItem><Link to='/'>Home</Link></BreadcrumbItem>
        <BreadcrumbItem active>Users</BreadcrumbItem>
      </Breadcrumb>
    </div>

    <Button color='primary' onClick={props.newUser}><FaPlus /> New User</Button>

    <Table className='mt-2'>
      <thead>
        <tr>
          {
            Object.keys(sortableHeaders).map(type =>
              <SortableTableHeader key={type} type={type}
                label={sortableHeaders[type]}
                onClick={props.onSorts[type]}
                sortDirection={props.sortDirection}
                sortBy={props.sortBy} />
            )
          }
        </tr>
      </thead>
      <tbody>
        {props.rows.map((row, i) =>
          <tr key={i}>
            <td><Link to={'/users/edit/' + row.id}>{row.email}</Link></td>
            <td>{row.firstName}</td>
            <td>{row.lastName}</td>
          </tr>
        )}
      </tbody>
    </Table>

    <Pagination
      total={props.total}
      limit={props.limit}
      history={props.history}
      match={props.match} />

  </div>

UsersList.propTypes = {
  total: PropTypes.number,
  limit: PropTypes.number,
  sortBy: PropTypes.string,
  match: PropTypes.object,
  history: PropTypes.object,
  rows: PropTypes.array,
  newUser: PropTypes.func
}

export default UsersList



// WEBPACK FOOTER //
// ./src/pages/UsersList/UsersList.js